var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvIcn4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.051,
    height: 74.625,
    viewBox: "0 0 74.051 74.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "env-icn4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2427",
    "data-name": "Groupe 2427",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 74.051,
    height: 74.625,
    rx: 20,
    fill: "rgba(255,186,70,0.17)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2733",
    "data-name": "Groupe 2733",
    transform: "translate(-609.231 -14.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3018",
    "data-name": "Trac\\xE9 3018",
    d: "M665.917,204.1h4.778c-.7,2.775-.251,4.417,1.523,5.618a4.477,4.477,0,0,0,5.135-.132c1.651-1.224,2.065-2.936,1.308-5.476h3.2v.465c0,1.3.008,2.591,0,3.887,0,.459.046.878.521,1.083s.808-.033,1.143-.359a2.851,2.851,0,0,1,4.708.973,2.756,2.756,0,0,1-1.036,3.173,2.909,2.909,0,0,1-3.514-.207,3.193,3.193,0,0,1-.249-.244.864.864,0,0,0-1.032-.271.89.89,0,0,0-.54.923c.006,1.96,0,3.92,0,5.88v.525c-.05.039-.076.076-.1.075-2.432-.038-4.875.222-7.274-.473a12.031,12.031,0,0,1-8.561-11.111C665.9,207,665.917,205.573,665.917,204.1Z",
    transform: "translate(-36.398 -151.06)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3019",
    "data-name": "Trac\\xE9 3019",
    d: "M681.819,71.887v5.052c-2.441-.894-4.526-.509-5.949,1.81a4.23,4.23,0,0,0,.495,4.922c1.308,1.53,2.932,1.8,5.446.893v3.269h-1.938c-.88,0-1.76.008-2.64,0a.924.924,0,0,0-1,.572.9.9,0,0,0,.343,1.053,2.627,2.627,0,0,1,.741,2.951,2.751,2.751,0,0,1-2.518,1.8,2.714,2.714,0,0,1-2.668-1.571,2.641,2.641,0,0,1,.646-3.216.883.883,0,0,0-.64-1.59c-.1,0-.2,0-.3,0h-5.855c-.038-.05-.076-.076-.075-.1.036-2.449-.235-4.913.484-7.322a12.017,12.017,0,0,1,11.241-8.52C679.011,71.873,680.388,71.887,681.819,71.887Z",
    transform: "translate(-36.38 -36.41)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3020",
    "data-name": "Trac\\xE9 3020",
    d: "M798.112,165.407V162.29h2.742c.614,0,1.229-.009,1.843,0a.918.918,0,0,0,1-.573.9.9,0,0,0-.35-1.052,2.567,2.567,0,0,1-.748-2.858,2.645,2.645,0,0,1,2.3-1.876,2.719,2.719,0,0,1,2.748,1.246,2.665,2.665,0,0,1-.46,3.483c-.5.485-.574,1.025-.128,1.368a1.451,1.451,0,0,0,.822.248c2.025.02,4.05.011,6.061.011.037.041.078.065.078.089-.034,2.432.232,4.878-.47,7.274a12,12,0,0,1-11.244,8.579c-1.377.019-2.755,0-4.173,0v-5.044c2.437.886,4.534.5,5.946-1.855a4.146,4.146,0,0,0-.485-4.834C802.079,164.776,800.206,164.608,798.112,165.407Z",
    transform: "translate(-151.038 -109.274)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3021",
    "data-name": "Trac\\xE9 3021",
    d: "M758.6,87.677h-3.167c-.008-.167-.022-.327-.022-.486,0-1.345-.007-2.691,0-4.036a.935.935,0,0,0-.494-.953.949.949,0,0,0-1.054.191,8.644,8.644,0,0,1-1.315.792,2.337,2.337,0,0,1-2.72-.446,2.719,2.719,0,0,1,1.221-4.7,2.766,2.766,0,0,1,2.731.81.9.9,0,0,0,1.631-.674c-.009-1.943,0-3.887,0-5.83v-.557c3.629-.1,7.227-.307,10.417,1.849a11.856,11.856,0,0,1,5.519,9.939c.043,1.357.007,2.716.007,4.1h-4.79c.888-2.355.464-4.351-1.731-5.741a4.361,4.361,0,0,0-4.957.3C758.278,83.456,757.9,85.06,758.6,87.677Z",
    transform: "translate(-108.355 -36.276)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3022",
    "data-name": "Trac\\xE9 3022",
    d: "M633.5,34.66a4.782,4.782,0,1,1-4.8-4.767A4.792,4.792,0,0,1,633.5,34.66Z",
    transform: "translate(0)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3023",
    "data-name": "Trac\\xE9 3023",
    d: "M897.555,34.687a4.782,4.782,0,1,1-4.77-4.794A4.792,4.792,0,0,1,897.555,34.687Z",
    transform: "translate(-228.977 0)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3024",
    "data-name": "Trac\\xE9 3024",
    d: "M628.7,303.571a4.783,4.783,0,1,1,4.8-4.763A4.8,4.8,0,0,1,628.7,303.571Z",
    transform: "translate(0 -229.025)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3025",
    "data-name": "Trac\\xE9 3025",
    d: "M892.788,303.571a4.783,4.783,0,1,1,4.767-4.8A4.8,4.8,0,0,1,892.788,303.571Z",
    transform: "translate(-228.977 -229.025)",
    fill: "#ffaa1c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvIcn4);
export default __webpack_public_path__ + "static/media/env-icn4.89329d691922ae6cc1a141fa6b8e36b9.svg";
export { ForwardRef as ReactComponent };